"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '16' : _ref$size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#24292E' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.083334",
    d: "M8.18447 0H7.81524C7.4074 0 7.07678 0.330619 7.07678 0.738459V2.95384C7.07678 3.36168 7.4074 3.6923 7.81524 3.6923H8.18447C8.59231 3.6923 8.92293 3.36168 8.92293 2.95384V0.738459C8.92293 0.330619 8.59231 0 8.18447 0Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.166667",
    d: "M12.1595 1.16444L11.8397 0.979826C11.4865 0.775906 11.0349 0.896921 10.831 1.25012L9.72328 3.16869C9.51936 3.52189 9.64037 3.97353 9.99357 4.17745L10.3133 4.36206C10.6665 4.56598 11.1182 4.44497 11.3221 4.09177L12.4298 2.1732C12.6337 1.82 12.5127 1.36836 12.1595 1.16444Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.25",
    d: "M15.0204 4.15973L14.8358 3.83996C14.6319 3.48676 14.1802 3.36575 13.827 3.56967L11.9085 4.67736C11.5553 4.88128 11.4342 5.33291 11.6382 5.68611L11.8228 6.00587C12.0267 6.35907 12.4783 6.48009 12.8315 6.27617L14.7501 5.16848C15.1033 4.96456 15.2243 4.51293 15.0204 4.15973Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.333334",
    d: "M16 8.18459V7.81536C16 7.40752 15.6694 7.0769 15.2615 7.0769H13.0462C12.6383 7.0769 12.3077 7.40752 12.3077 7.81536V8.18459C12.3077 8.59243 12.6383 8.92305 13.0462 8.92305H15.2615C15.6694 8.92305 16 8.59243 16 8.18459Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.416667",
    d: "M14.8358 12.1597L15.0204 11.84C15.2243 11.4868 15.1033 11.0351 14.7501 10.8312L12.8316 9.72352C12.4784 9.5196 12.0267 9.64062 11.8228 9.99382L11.6382 10.3136C11.4343 10.6668 11.5553 11.1184 11.9085 11.3223L13.827 12.43C14.1802 12.6339 14.6319 12.5129 14.8358 12.1597Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.5",
    d: "M11.8402 15.0206L12.1599 14.836C12.5131 14.6321 12.6341 14.1805 12.4302 13.8273L11.3225 11.9087C11.1186 11.5555 10.667 11.4345 10.3138 11.6384L9.994 11.823C9.6408 12.0269 9.51979 12.4786 9.72371 12.8318L10.8314 14.7503C11.0353 15.1035 11.487 15.2246 11.8402 15.0206Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.583334",
    d: "M7.81516 16H8.18439C8.59223 16 8.92285 15.6694 8.92285 15.2615V13.0462C8.92285 12.6383 8.59223 12.3077 8.18439 12.3077H7.81516C7.40732 12.3077 7.0767 12.6383 7.0767 13.0462V15.2615C7.0767 15.6694 7.40732 16 7.81516 16Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.666667",
    d: "M3.84015 14.8348L4.15991 15.0194C4.51311 15.2234 4.96475 15.1023 5.16867 14.7491L6.27636 12.8306C6.48028 12.4774 6.35926 12.0257 6.00606 11.8218L5.6863 11.6372C5.3331 11.4333 4.88147 11.5543 4.67755 11.9075L3.56986 13.8261C3.36594 14.1793 3.48695 14.6309 3.84015 14.8348Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.75",
    d: "M0.979359 11.8395L1.16397 12.1593C1.36789 12.5125 1.81953 12.6335 2.17273 12.4296L4.0913 11.3219C4.4445 11.118 4.56552 10.6664 4.3616 10.3132L4.17698 9.99339C3.97306 9.64019 3.52143 9.51918 3.16823 9.7231L1.24965 10.8308C0.896454 11.0347 0.775439 11.4863 0.979359 11.8395Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.833334",
    d: "M0 7.81541L0 8.18464C0 8.59248 0.330619 8.9231 0.738459 8.9231H2.95384C3.36168 8.9231 3.6923 8.59248 3.6923 8.18464V7.81541C3.6923 7.40757 3.36168 7.07695 2.95384 7.07695H0.738459C0.330619 7.07695 0 7.40757 0 7.81541Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: "0.916667",
    d: "M1.1642 3.83954L0.979581 4.1593C0.775662 4.5125 0.896676 4.96414 1.24988 5.16806L3.16845 6.27575C3.52165 6.47967 3.97328 6.35865 4.1772 6.00545L4.36182 5.68569C4.56574 5.33249 4.44472 4.88086 4.09152 4.67694L2.17295 3.56925C1.81975 3.36533 1.36812 3.48634 1.1642 3.83954Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.15948 0.978626L3.83972 1.16324C3.48652 1.36716 3.3655 1.8188 3.56942 2.172L4.67711 4.09057C4.88103 4.44377 5.33267 4.56478 5.68587 4.36086L6.00563 4.17625C6.35883 3.97233 6.47984 3.52069 6.27592 3.16749L5.16824 1.24892C4.96432 0.895721 4.51268 0.774706 4.15948 0.978626Z",
    fill: fill
  }));
};

exports["default"] = _default;